<div class="no-data-wrapper">
    <div class="warning-icon-wrap with-info-icon">
        <span class="ss-info icon fix-left">&nbsp;</span>
    </div>
    <div class="warning-message" translate>{{ warningMsg }}</div>
</div>
